import { IAcceptedOfferDto, IChangeOfferParams, IFetchOffersParams, IMakeOfferDto, IOfferDto, IOfferedBuyProductDto, IOfferedDealProductDto, IOfferedSellProductDto, ITabUnreadMessageCountDto } from "@/Models/Chat";
import apiService from "../ApiService";


async function getBuyOffers(params: IFetchOffersParams) {
  return await apiService
    .setUrl(`/offers`)
    .setMethod("GET")
    .setParams(params)
    .request<IOfferedBuyProductDto[]>();
};
async function getSellOffers(params: IFetchOffersParams) {
  return await apiService
    .setUrl(`/offers`)
    .setMethod("GET")
    .setParams(params)
    .request<IOfferedSellProductDto[]>();
};
async function getDealOffers(params: IFetchOffersParams) {
  return await apiService
    .setUrl(`/offers`)
    .setMethod("GET")
    .setParams(params)
    .request<IOfferedDealProductDto[]>();
};
async function getOfferById(id: number) {
  return await apiService
    .setUrl(`/offers/${id}`)
    .setMethod("GET")
    .request<IOfferDto>();
};
async function getUnreadedOffers() {
  return await apiService
    .setUrl(`/offers/unreaded`)
    .setMethod("GET")
    .request<ITabUnreadMessageCountDto[]>();
};
async function getAcceptedOffers() {
  return await apiService
    .setUrl(`/offers/accepted`)
    .setMethod("GET")
    .request<IAcceptedOfferDto[]>();
};
async function postOffer(productId: number, body: IMakeOfferDto) {
  return await apiService
    .setUrl(`/offers/${productId}`)
    .setMethod("POST")
    .setBody(body)
    .request<IOfferDto>();
};
async function updateOffer(productId: number, body: IMakeOfferDto) {
  return await apiService
  .setUrl(`/offers/${productId}`)
  .setMethod("PUT")
  .setBody(body)
  .request<IOfferDto>();
};
async function changeOffer(params: IChangeOfferParams) {
  return await apiService
    .setUrl(`/offers/${params.id}/change`)
    .setMethod("POST")
    .setParams(params)
    .request<IOfferDto>();
};

const OfferApi = {
  getBuyOffers,
  getSellOffers,
  getDealOffers,
  getOfferById,
  getUnreadedOffers,
  getAcceptedOffers,
  postOffer,
  changeOffer,
  updateOffer,
}

export default OfferApi;
